export default __webpack_public_path__ + "static/media/resumo.b4a6a4d3.svg";